/**
 * At a glance common constant values
 *
 * @type {{}}
 */

module.exports = {


    /**
     * Default size of photo loaded to at a glance
     */
    DEFAULT_PHOTO_SIZE: 1280,
    USED_PHOTO_SIZE: 500,
    ARROW_HANDLER:[
        '<span class="left carousel-control " role="button">',
        '<span class="icon-prev" aria-hidden="true"></span>',
        '</span>',
        '<span class="right carousel-control " role="button">',
        '<span class="icon-next" aria-hidden="true"></span>',
        '</span>']
};



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/at-a-glance-carousel/constant.js
// module id = 146
// module chunks = 0 1 27